import gql from 'graphql-tag'

const EmailMessage = gql`
  query EmailMessage($id: ID!) {
    emailMessage(id: $id) {
      id
      from
      subject
      htmlPart
      content
      senderType
      documentsConnection {
        edges {
          cursor
          node {
            documentId
            id
            attachmentContentType
            attachmentFileName
            documentUrl
            status
            type
          }
        }
      }
    }
  }
`

export { EmailMessage }


// WEBPACK FOOTER //
// ./src/queries/EmailMessageSimplified.js